var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckmarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.096,
    height: 25.096,
    viewBox: "0 0 25.096 25.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 10,
    rx: 9.5,
    ry: 10,
    transform: "translate(2.925 2.676)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.923,3.375A12.548,12.548,0,1,0,28.471,15.923,12.546,12.546,0,0,0,15.923,3.375Zm6.425,9.079-8.066,8.1h-.006a1.09,1.09,0,0,1-.7.332,1.056,1.056,0,0,1-.706-.344L9.492,17.166a.24.24,0,0,1,0-.344l1.074-1.074a.233.233,0,0,1,.338,0l2.679,2.679,7.36-7.414a.238.238,0,0,1,.169-.072h0a.219.219,0,0,1,.169.072L22.336,12.1A.238.238,0,0,1,22.348,12.454Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#2dce89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmarkCircle);
export default __webpack_public_path__ + "static/media/green-checkmark-circle.69034a5c7a9c7afa8920aa5a9e3092fa.svg";
export { ForwardRef as ReactComponent };